import { render, staticRenderFns } from "./integration_settings.vue?vue&type=template&id=975ad936"
import script from "./integration_settings.vue?vue&type=script&lang=js"
export * from "./integration_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports